import Axios from 'axios';
 
const ACCOUNT = '/account';
 
export default {
  getAll() {
    return Axios.get(ACCOUNT);
  },
 
  get(id) {
    return Axios.get(`${ACCOUNT}/${id}`);
  },
 
  create(data) {
    return Axios.post(ACCOUNT, data);
  },
 
  update(id, data) {
    return Axios.put(`${ACCOUNT}/${id}`, data);
  },
 
  delete(id) {
    return Axios.delete(`${ACCOUNT}/${id}`);
  },

};